import request from '../utils/request';

//  const url = 'https://www.sundaytek.com:10111/admin/'
 const url = 'https://iot.sundaytek.com/admin/'
//const url = 'http://127.0.0.1:10111/admin/'

// 登录
export const login = query => {
    return request({
        url: `${url}login`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 测试https登录
// export const Alogin = query => {
//     return request({
//         url: `https://iot.sundaytek.com/admin/login`,
//         method: 'post',
//         data:query,
//          headers:{
//             "token":localStorage.getItem('token') ? localStorage.getItem('token') : ''
//         }
//     });
// };

// 增加企业
export const AddCompany = query => {
    return request({
        url: `${url}addCompany`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 解除报警
export const closeAlerm = query => {
    return request({
        url: `${url}closeAlerm`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 查找用户绑定的企业
export const QueryCompanyUser = query => {
    return request({
        url: `${url}queryCompanyUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 查找企业信息
export const QueryCompanyInfo = query => {
    return request({
        url: `${url}queryCompanyInfo`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 获取项目列表
export const QueryProjectList = query => {
    return request({
        url: `${url}queryProjectList`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};


// 查询所有企业
export const AllCompany = query => {
    return request({
        url: `${url}allCompany`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 修改项目名称
export const UpdateProjectName = query => {
    return request({
        url: `${url}updateProjectName`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 查找项目中的设备
export const QueryProjectDevice = query => {
    return request({
        url: `${url}queryProjectDevice`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 查询项目绑定的企业
export const QueryProjectBind = query => {
    return request({
        url: `${url}queryProjectBind`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 设置设备的经纬度信息
export const UpdateDeviceLocation = query => {
    return request({
        url: `${url}updateDeviceLocation`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 获取大屏设备数据
export const GetDeviceData = query => {
    return request({
        url: `${url}getDeviceData`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 查询设备报警信息
export const QueryAlermMessage = query => {
    return request({
        url: `${url}queryAlermMessage`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 查找企业绑定的项目
export const QueryCompanyProject = query => {
    return request({
        url: `${url}queryCompanyProject`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 查看企业绑定的用户
export const QueryUserCompany = query => {
    return request({
        url: `${url}queryUserCompany`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 查询用户信息
export const QueryUser = query => {
    return request({
        url: `${url}queryUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 查询项目名称
export const QueryProjectName = query => {
    return request({
        url: `${url}queryProjectName`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 删除企业
export const DeleteCompany = query => {
    return request({
        url: `${url}deleteCompany`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 查询用户
export const GetAllUser = query => {
    return request({
        url: `${url}getAllUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 增加用户
export const AddUser = query => {
    return request({
        url: `${url}addUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 修改用户姓名
export const EditUserName = query => {
    return request({
        url: `${url}editUserName`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 重置用户密码
export const ResetUserPassword = query => {
    return request({
        url: `${url}resetUserPassword`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 删除用户
export const DeleteUser = query => {
    return request({
        url: `${url}deleteUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 查询企业未绑定的用户
export const QueryUnbindUser = query => {
    return request({
        url: `${url}queryUnbindUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 绑定用户与企业
export const CompanyUser = query => {
    return request({
        url: `${url}companyUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 绑定项目与企业
export const CompanyProject = query => {
    return request({
        url: `${url}companyProject`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 查询企业未绑定的项目
export const QueryUnbindProject = query => {
    return request({
        url: `${url}queryUnbindProject`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 解绑企业与用户
export const CancelUserBindCompany = query => {
    return request({
        url: `${url}cancelUserBindCompany`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 条件查询未绑定企业的用户
export const SearchUnCompanyBindUser = query => {
    return request({
        url: `${url}searchUnCompanyBindUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 条件查找产品中的设备
export const CondProjectDevice = query => {
    return request({
        url: `${url}condProjectDevice`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 切换设备维护状态
export const ChangeMaintain = query => {
    return request({
        url: `${url}changeMaintain`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 获取设备详情(已经知道项目id)
export const GetDeviceDetailProjcet = query => {
    return request({
        url: `${url}getDeviceDetailProjcet`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 历史属性查询
export const QueryHistoryProptyProject = query => {
    return request({
        url: `${url}queryHistoryProptyProject`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 历史多属性查询
export const QueryHistoryMoreProptyProject = query => {
    return request({
        url: `${url}queryHistoryMoreProptyProject`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 历史事件信息查询
export const QueryHistoryEventProject = query => {
    return request({
        url: `${url}queryHistoryEventProject`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 博实杰盒子历史事件信息查询
export const QueryBsjHistoryEventProject = query => {
    return request({
        url: `${url}queryBsjHistoryEventProject`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 佳佳眼积水监测设备历史事件信息查询
export const QueryJjyHistoryEventProject = query => {
    return request({
        url: `${url}QueryJjyHistoryEventProject`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 佳佳眼积水监测设备历史事件信息查询
export const QuerySzjcHistoryEventProject = query => {
    return request({
        url: `${url}QuerySzjcHistoryEventProject`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 佳佳眼雷达水位计设备历史事件信息查询
export const QueryLdWaterHistoryEventProject = query => {
    return request({
        url: `${url}QueryLdWaterHistoryEventProject`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 获取全部设备列表并返回projectId
export const GetAllDeviceList = query => {
    return request({
        url: `${url}getAllDeviceList`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 修改密码
export const ChangeUserPwd = query => {
    return request({
        url: `${url}changeUserPwd`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 分页查找设备列表
export const GetAllDeviceListLimit = query => {
    return request({
        url: `${url}getAllDeviceListLimit`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 搜索企业
export const QueryCompany = query => {
    return request({
        url: `${url}queryCompany`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 搜索用户
export const SearchUser = query => {
    return request({
        url: `${url}searchUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 解绑项目与企业
export const RemoveProjectBindCompany = query => {
    return request({
        url: `${url}removeProjectBindCompany`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 修改水位设备报警水位
export const UpdateDeviceAlarm = query => {
    return request({
        url: `${url}updateDeviceAlarm`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 修改建仁雨量报警值
export const UpdateJRYLDeviceAlarm = query => {
    return request({
        url: `${url}updateJRYLDeviceAlarm`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 通知栏信息
export const Notification = query => {
    return request({
        url: `${url}notification`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 增加维保人员用户
export const AddMaintainUser = query => {
    return request({
        url: `${url}addMaintainUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 查找企业维保用户信息
export const GetAllMaintainUser = query => {
    return request({
        url: `${url}getAllMaintainUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 修改维保用户姓名
export const EditMaintainUserName = query => {
    return request({
        url: `${url}editMaintainUserName`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 重置维保用户密码
export const ResetMaintainUserPassword = query => {
    return request({
        url: `${url}resetMaintainUserPassword`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 删除维保用户
export const DeleteMaintainUser = query => {
    return request({
        url: `${url}DeleteMaintainUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};


// 设置阈值
export const SetLimit = query => {
    return request({
        url: `${url}SetLimit`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 设置阈值
export const SetLimitSzjc = query => {
    return request({
        url: `${url}SetLimitSzjc`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 下发工单
export const AddTask = query => {
    return request({
        url: `${url}addTask`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 查询工单数量
export const QueryATaskCount = query => {
    return request({
        url: `${url}queryATaskCount`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};




// 删除工单
export const DeleteTask = query => {
    return request({
        url: `${url}deleteTask`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};


// 搜索工单信息
export const SearchATask = query => {
    return request({
        url: `${url}searchATask`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};
// 查询维保人员信息
export const QueryMaintainUser = query => {
    return request({
        url: `${url}queryMaintainUser`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 根据设备名称以及产品ID获取设备详情
export const GetDeviceDetailProjcetDeviceName = query => {
    return request({
        url: `${url}getDeviceDetailProjcetDeviceName`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};

// 查询sim卡信息
export const QuerySim = query => {
    return request({
        url: `${url}querySim`,
        method: 'post',
        data: query,
        headers: {
            "token": localStorage.getItem('token') ? localStorage.getItem('token') : ''
        }
    });
};







